// ── Event bar / pill visual tokens ──────────────────────────────────────────
// Single source of truth for all event rendering across the calendar grid.
// Any change here propagates to multi-day bars, single-day all-day bars,
// and timed mini-pills automatically.

/** Height in px for all-day and multi-day bars in the header band */
export const EVENT_BAR_H = 18;

/** Vertical gap in px between stacked bars */
export const EVENT_BAR_GAP = 2;

/** Border-radius in px for bar start/end caps */
export const EVENT_BAR_RADIUS = 4;

/** Height in px for timed mini-pills in the day cell body */
export const EVENT_PILL_H = 14;

/** Border-radius in px for timed mini-pills */
export const EVENT_PILL_RADIUS = 2;

/** Font size for bar label text */
export const EVENT_BAR_FONT_SIZE = '10px';

/** Font size for mini-pill label text */
export const EVENT_PILL_FONT_SIZE = '8px';

/** Font weight for all event labels */
export const EVENT_LABEL_FONT_WEIGHT = '600';
